@if(data[column.field]){
    <bizz-icon class="size-4" iconName="paperclip"></bizz-icon>
}
